import styled from "styled-components";

export const StyledFooter = styled.footer`
  display: flex;
  flex-direction: row;
  flex: 0;
  justify-content: space-between;
  align-items: center;
  height: 7.2rem;
  min-height: 7.2rem;
  padding: 2.4rem;
  border-top: 0.1rem solid var(--neutral-neutral-80, #b5b5b5);

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 1.6rem;
    border-top: none;
    padding-bottom: 11rem;
  }
`;

export const StyledLinks = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;

  @media only screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }
`;

export const LinkBorder = styled.div`
  border: 0.1rem solid var(--primary-primary-50, #007fad);
  height: 1.6rem;
`;
